export const vacinasProps = {
  basename: "/plataforma/vacinas",
};
